import React from "react";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  InputLabel,
  Stack,
  Tooltip,
} from "@mui/material";
import { Divider } from "@aws-amplify/ui-react";
import CancelIcon from "@mui/icons-material/Cancel";
import { customColors } from "models/customColors";

export const LocationSelector = ({
  locations,
  selectedLocationIds,
  handleChangeLocation,
  resetSelectedLocations,
  isSelectedLocationsChanged,
}) => {
  if (!locations?.length) return null;

  return (
    <Stack mt={0.5} mb={0.5}>
      <InputLabel sx={{ textAlign: "left" }}>
        Assigned Locations for notifications:
      </InputLabel>
      <Divider />
      <Stack
        flex={1}
        maxHeight={150}
        sx={{ overflowY: "auto", position: "relative" }}
      >
        {isSelectedLocationsChanged && (
          <Tooltip
            title="Discard location changes"
            placement="top-end"
            arrow
            sx={{ position: "absolute", top: 2, right: 2 }}
          >
            <IconButton onClick={resetSelectedLocations}>
              <CancelIcon />
            </IconButton>
          </Tooltip>
        )}
        {locations.map(([id, label]) => {
          const selected = selectedLocationIds.includes(id);

          return (
            <FormControlLabel
              key={id}
              control={
                <Checkbox
                  checked={selected}
                  onChange={(e) => handleChangeLocation(e, id, label)}
                  name={id}
                  sx={{ padding: "4px 8px" }}
                />
              }
              label={label}
              sx={{
                textAlign: "left",
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.875rem",
                  color: "#000000",
                },
                backgroundColor: selected
                  ? customColors.selectedCheckboxLabel
                  : customColors.white,
                "&:hover": { bgcolor: customColors.selector }
              }}
            />
          );
        })}
      </Stack>
      <Divider />
    </Stack>
  );
};
